
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
       Hello! This is trial app!
       Hello! 
      </header>
    </div>
  );
}

export default App;
